import {URL_PARAMS} from "../types";
import {Navigation} from "@ok/web/modules/navigation/Navigation";

import {buildUrl} from "@ok/utils/urls";


type URLType = {
    isShort: boolean;
    isStandard: boolean;
    isClipFullscreen: boolean;
}

export enum UpdateType {
    UPDATE,
    CLEAR
}

type LinkHelperConfig = {
    isHandleSystemBackFeatureEnabled: boolean,
    statesForDisableSystemBackHandling: string[] | null
}
export class LinkHelper {
    private previousHref: URL | null = null;

    public path = "/clip";

    private readonly isHandleSystemBackFeatureEnabled: boolean;
    private readonly statesForDisableSystemBackHandling: string[] | null;

    constructor(config: LinkHelperConfig) {
        this.isHandleSystemBackFeatureEnabled = config.isHandleSystemBackFeatureEnabled;
        this.statesForDisableSystemBackHandling = config.statesForDisableSystemBackHandling;
    }


    getLinkOnCurrentClip1(ownerId?: number, clipId?: number) {
        return document.location.origin + this.getLinkOnCurrentClip(ownerId, clipId);
    }

    //TODO: #ms не польный это линк, а часть после слеша
    getLinkOnCurrentClip(ownerId?: number, clipId?: number) {
        let params = {} as Record<string, number>;

        if (ownerId != null) {
            params[URL_PARAMS.OWNER] = ownerId;
        }

        if (clipId != null) {
            params[URL_PARAMS.CLIP] = clipId;
        }

        const result = buildUrl(this.path, params);

        return result;
    }

    updateHref(updateType: UpdateType, clipId?: number, ownerId?: number) {
        const currentURL = new URL(document.location.href);
        const URLType: URLType = this.getURLType(currentURL);

        if (!URLType.isClipFullscreen) {
            this.previousHref = new URL(currentURL);

            currentURL.search = "";
            currentURL.pathname = this.path;
        } else if (URLType.isStandard) {
            currentURL.search = "";
            currentURL.pathname = this.path;
        }

        if (updateType === UpdateType.UPDATE && clipId && ownerId) {
            currentURL.search = `?${URL_PARAMS.OWNER}=${ownerId.toString()}&${URL_PARAMS.CLIP}=${clipId.toString()}`;

            Navigation.replaceState(currentURL.toString());
        } else if (updateType === UpdateType.CLEAR) {
            this.restorePreviousURL();
        }
    }

    restorePreviousURL() {
        if (this.previousHref) {
            Navigation.replaceState(this.previousHref.toString());
        }
    }

    getURLType(href: URL) {
        let result: URLType = {
            isShort: false,
            isStandard: false,
            isClipFullscreen: false,
        };

        const url = new URL(href);

        if (url.pathname === "/dk") {
            const params = url.search.split("&");
            const stCmdParam = params.find((elem) => elem.includes("st.cmd"));

            if (stCmdParam) {
                result.isStandard = true;
                const parts = stCmdParam.split("=");
                const value = parts[1];

                if (value && value === "clipsFullscreen") {
                    result.isClipFullscreen = true;
                }
            }
        } else {
            result.isShort = true;

            if (url.pathname === "/clip") {
                result.isClipFullscreen = true;
            }
        }

        return result;
    }

    pushCurrentUrlForSaveInBrowserHistory() {
        if (!this.isCurrentStateInStatesForDisableSystemBackHandling()) {
            // Для закрытия фуллскрина системным назад, добавляем url с которого заходим в фуллскрин в историю
            Navigation.pushState(document.location.href);
        }
    }

    isCurrentStateInStatesForDisableSystemBackHandling() {
        const currentState = window.pageCtx && window.pageCtx.stateId;

        if (currentState && this.statesForDisableSystemBackHandling && this.isHandleSystemBackFeatureEnabled) {
            return this.statesForDisableSystemBackHandling.some(stateToAvoid => stateToAvoid === currentState);
        } else {
            return true;
        }
    }
}
